// 注册一个全局自定义指令 `v-prevent-scroll`
export default {
  bind(el, binding, vnode) {
    // 记录触摸起始位置
    let startY = 0
    // 记录滚动容器
    let scrollContainer = el

    // 检查元素是否可滚动，如果不可滚动则查找子元素
    if (el.scrollHeight <= el.clientHeight) {
      const scrollable =
        el.querySelector('*[scrollable]') ||
        el.querySelector('.scrollable') ||
        el.querySelector('div[style*="overflow-y: auto"]') ||
        el.querySelector('div[style*="overflow-y: scroll"]')

      if (scrollable) {
        scrollContainer = scrollable
      }
    }

    // 触摸开始事件
    const handleTouchStart = (e) => {
      startY = e.touches[0].clientY
    }

    // 触摸移动事件
    const handleTouchMove = (e) => {
      if (!scrollContainer) return

      const currentY = e.touches[0].clientY
      const diffY = startY - currentY // 计算滑动距离

      const scrollTop = scrollContainer.scrollTop
      const scrollHeight = scrollContainer.scrollHeight
      const clientHeight = scrollContainer.clientHeight

      // 判断是否滚动到顶部且继续向上滑动
      const isAtTop = scrollTop === 0 && diffY < 0
      // 判断是否滚动到底部且继续向下滑动
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 1 && diffY > 0

      // 如果到达顶部或底部，阻止事件传播
      if (isAtTop || isAtBottom) {
        e.preventDefault()
        e.stopPropagation()
      }

      // 更新起始位置
      startY = currentY
    }

    // 绑定事件
    scrollContainer.addEventListener('touchstart', handleTouchStart, { passive: true })
    scrollContainer.addEventListener('touchmove', handleTouchMove, { passive: false })

    // 存储事件处理函数，以便在unbind时移除
    el.__preventScrollHandlers = {
      handleTouchStart,
      handleTouchMove,
      scrollContainer,
    }
  },

  // 解绑时移除事件监听
  unbind(el) {
    const handlers = el.__preventScrollHandlers
    if (handlers && handlers.scrollContainer) {
      handlers.scrollContainer.removeEventListener('touchstart', handlers.handleTouchStart)
      handlers.scrollContainer.removeEventListener('touchmove', handlers.handleTouchMove)
    }
    delete el.__preventScrollHandlers
  },
}
